var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTeamsInfo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_62",
    "data-name": "Rectangle 62",
    width: 6.796,
    height: 17.772,
    fill: "#065683"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_15975",
    "data-name": "Group 15975",
    transform: "translate(-585 -267.622)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3",
    "data-name": "Ellipse 3",
    cx: 14.5,
    cy: 14.5,
    r: 14.5,
    transform: "translate(585 267.622)",
    fill: "#bee3f8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_60",
    "data-name": "Group 60",
    transform: "translate(596.101 273.128)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_59",
    "data-name": "Group 59",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    "data-name": "Path 40",
    d: "M6.8,64.448a.418.418,0,0,1-.136.306A17.469,17.469,0,0,1,3.9,67.026a3.338,3.338,0,0,1-1.593.538,1.379,1.379,0,0,1-1.058-.432,1.565,1.565,0,0,1-.388-1.106c0-1.172.664-3.9,2.033-8.322a2.166,2.166,0,0,0,.052-.215,1.754,1.754,0,0,0-.177.1A12.6,12.6,0,0,0,1.313,58.9a.425.425,0,0,1-.556.033l-.593-.459a.419.419,0,0,1-.162-.3.432.432,0,0,1,.11-.323,10.842,10.842,0,0,1,2.55-2.183,4.4,4.4,0,0,1,2.092-.68,1.4,1.4,0,0,1,.929.288,1.046,1.046,0,0,1,.382.837,19.473,19.473,0,0,1-.886,3.42,32.965,32.965,0,0,0-1.4,5.571,12.07,12.07,0,0,0,1.776-1.482.426.426,0,0,1,.59,0l.523.512a.437.437,0,0,1,.129.309Z",
    transform: "translate(0 -49.792)",
    fill: "#065683"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    "data-name": "Path 41",
    d: "M41.346,1.407a1.923,1.923,0,0,1-.523,1.327,1.636,1.636,0,0,1-1.232.587,1.322,1.322,0,0,1-.98-.413,1.44,1.44,0,0,1-.386-1.03,1.884,1.884,0,0,1,.5-1.317A1.642,1.642,0,0,1,39.968,0a1.338,1.338,0,0,1,.987.407A1.369,1.369,0,0,1,41.346,1.407Z",
    transform: "translate(-34.613)",
    fill: "#065683"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamsInfo);
export default __webpack_public_path__ + "static/media/teams-info.c08758817452bf0bc60182918316cc08.svg";
export { ForwardRef as ReactComponent };